/**
 * @generated SignedSource<<ad7436621b23c5310f492efeb33e4352>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type _DeleteMatterInput = {
  clientMutationId: string;
  matterId: string;
  tenantId: string;
};
export type useDeleteMatterMutation$variables = {
  input: _DeleteMatterInput;
};
export type useDeleteMatterMutation$data = {
  readonly _deleteMatter: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly message: string;
      readonly path: ReadonlyArray<string>;
      readonly type: string;
    }> | null;
    readonly matter: {
      readonly id: string;
    } | null;
  } | null;
};
export type useDeleteMatterMutation = {
  response: useDeleteMatterMutation$data;
  variables: useDeleteMatterMutation$variables;
};
const node: ConcreteRequest = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }],
    v2 = {
      "alias": null,
      "args": null,
      "concreteType": "MutationError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "path",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      }],
      "storageKey": null
    },
    v3 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "useDeleteMatterMutation",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": "_DeleteMatterPayload",
        "kind": "LinkedField",
        "name": "_deleteMatter",
        "plural": false,
        "selections": [v2 /*: any*/, {
          "alias": null,
          "args": null,
          "concreteType": "_Matter",
          "kind": "LinkedField",
          "name": "matter",
          "plural": false,
          "selections": [v3 /*: any*/],

          "storageKey": null
        }],
        "storageKey": null
      }],
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "useDeleteMatterMutation",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": "_DeleteMatterPayload",
        "kind": "LinkedField",
        "name": "_deleteMatter",
        "plural": false,
        "selections": [v2 /*: any*/, {
          "alias": null,
          "args": null,
          "concreteType": "_Matter",
          "kind": "LinkedField",
          "name": "matter",
          "plural": false,
          "selections": [v3 /*: any*/, {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }],
          "storageKey": null
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "3ec9577cdb2b233e2f063aa6b1f47949",
      "id": null,
      "metadata": {},
      "name": "useDeleteMatterMutation",
      "operationKind": "mutation",
      "text": "mutation useDeleteMatterMutation(\n  $input: _DeleteMatterInput!\n) {\n  _deleteMatter(input: $input) {\n    errors {\n      code\n      path\n      message\n      type\n    }\n    matter {\n      id\n    }\n  }\n}\n"
    }
  };
}();
(node as any).hash = "c5ee25dddb470b6ffe6d9bdeb1e5719e";
export default node;